import { Api } from 'utils';

class SupportService {
	
	static get = async (params?: any) => Api.createResponse('client/support',params);
	static send = async (params?: any) => Api.createResponse('client/support/send',params);

}

export default SupportService;